import { TranslationStatusOption } from '../../utils'

export enum HostFamilyPriceTypeEnum {
  STUDENT = 'STUDENT',
  STAFF = 'STAFF'
}

export const hostFamilyPriceTypeEnumMapping: Record<
  HostFamilyPriceTypeEnum,
  TranslationStatusOption
> = {
  STAFF: {
    label: 'host.family.price.type.enum.STAFF',
    variant: 'fushia'
  },
  STUDENT: {
    label: 'host.family.price.type.enum.STUDENT',
    variant: 'blue'
  }
}
